import { Map, fromJS } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    gettingHelpData: false,
    helpData: null,
})

const help = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.GET_HELP_DATA: {
            return state.merge({
                gettingHelpData: true,
                helpData: null,
            })
        }

        case actions.GET_HELP_DATA_SUCCESS: {
            return state.merge({
                gettingHelpData: false,
                helpData: fromJS(payload),
            })
        }

        case actions.GET_DELIVERY_DETAILS_FAILED: {
            return state.merge({
                gettingHelpData: false,
                helpData: null,
            })
        }

        default:
            return state
    }
}
export default help
